import { BuildingStateType } from "../utils/network/generated/protoTypes";
import { selectAllExistingBuildingInfo } from "./selectExistingBuildingInfo";
export var selectWorkersInfo = function (state) {
    var occupied = 0;
    var total = 0;
    selectAllExistingBuildingInfo(state, true).forEach(function (val) {
        if (val.proto.state === BuildingStateType.CONSTRUCTING) {
            return;
        }
        var levelToConsider = val.proto.state === BuildingStateType.UPGRADING
            ? val.proto.stage || 0
            : Math.max(val.proto.stage || 1) - 1;
        var workers = val.balancing.stage[levelToConsider].workers || 0;
        if (workers < 0) {
            occupied += workers;
        }
        else {
            total += workers;
        }
    });
    return {
        free: total - Math.abs(occupied),
        total: total,
    };
};



//////////////////
// WEBPACK FOOTER
// ./src/selectors/selectWorkersInfo.ts
// module id = 270
// module chunks = 3